<div class="page-layout carded fullwidth inner-scroll">
    <div class="center px-20">
        <div class="content" fusePerfectScrollbar>
            <div id="pbi-container" class="pbi-container"></div>
        </div>
    </div>
</div>